import Service from '../abstract/service'
import Empresa from '../empresa'

export default class Retencao extends Service {
  constructor() {
    super()
    this._retencaoRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Retencao`
    )

    this._serviceEmpresa = new Empresa()
  }

  async create(values) {
    try {
      this._loading.setLoading(true, 'Cadastrando faixa de retenção')
      let doc = await this._retencaoRef.doc(`${values.apelido}`+`${values.papel.toUpperCase()}`)
      await doc.set(values)
      values.id = doc.id

      return Promise.resolve(values)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async update(retencaoId, values) {
    try {
      this._loading.setLoading(true, 'Atualizando faixa de retenção')
      delete values.id
      const retencao = await this._retencaoRef.doc(retencaoId)
      retencao.update({
        ...values
      })

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
  
  async delete(retencaoId) {
    try {
      this._loading.setLoading(true, 'Deletando faixa de retenção')
      const retencao = await this._retencaoRef.doc(retencaoId)
      retencao.delete()

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }



  async getByEmpresaPapel(items, dat) {
    let retencao = new Array()
    try {
      this._loading.setLoading(true, 'Carregando faixas de retenção')
      for (let item of items.empresas) {
        const empresa = dat.find(element => element.cnpj === item);

        const response = await this._retencaoRef
          .where("empresa", "==", empresa.cnpj)
          .where("papel", "==", items.papel)
          .get();

        if (!response.empty) {
          for (let doc of response.docs) {
            let faixa = doc.data();

            retencao.push({
              id: doc.id,
              nomeEmpresa: empresa.nome,
              ...faixa
            });
          }
        }
      }
      return Promise.resolve(adimplencia);
    } catch (error) {
      console.log("erro", error);
      console.error("Erro:", error);
      return Promise.reject(error);
    } finally {
      this._loading.setLoading(false);
    }
  }

  async getByCnpjPapel(cnpj, papel) {
    let retencao = new Array()
    try {
      this._loading.setLoading(true, 'Carregando faixas de retenção')

        const response = await this._retencaoRef
          .where("empresa", "==", cnpj)
          .where("papel", "==", papel)
          .get();
          
        if (!response.empty) {
          for (let doc of response.docs) {
            retencao.push(doc.data());
          }
        }
      return Promise.resolve(adimplencia);
    } catch (error) {
      console.log("erro", error);
      console.error("Erro:", error);
      return Promise.reject(error);
    } finally {
      this._loading.setLoading(false);
    }
  }



  async getAll() {
    try {
      this._loading.setLoading(true, 'Buscando todas faixas de retenção')
      const response = await this._retencaoRef.get()

      let retencao = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          retencao.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(retencao)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
